import {AcwrScore} from '../interfaces';

/**
 * ACWR is stored one row per day in no guaranteed order, so anything that wants
 * a player's current ratio has to sort before taking the head of the list.
 */
const getMostRecentAcwrScore = (acwrScores?: AcwrScore[]) =>
  [...(acwrScores ?? [])].sort(
    (a, b) =>
      new Date(b.date as string).getTime() -
      new Date(a.date as string).getTime(),
  )[0];

export {getMostRecentAcwrScore};
